import React, { useState } from 'react';
import emailjs from '@emailjs/browser';

const EmailCapture = ({ className = '' }) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage('');

    try {
      // EmailJS configuration - these should be set up in EmailJS dashboard
      // See EMAILJS_SETUP.md for configuration instructions
      const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

      // Check if EmailJS is configured
      if (!serviceID || !templateID || !publicKey || 
          serviceID === 'your_service_id_here' || 
          templateID === 'your_template_id_here' || 
          publicKey === 'your_public_key_here') {
        throw new Error('EmailJS not configured. Please see EMAILJS_SETUP.md for setup instructions.');
      }

      // Template parameters for EmailJS
      const templateParams = {
        to_email: 'billyswingco@gmail.com',
        from_email: email,
        subscriber_email: email,
        message: `New newsletter subscription from: ${email}`,
        timestamp: new Date().toLocaleString(),
      };

      // Send email via EmailJS
      await emailjs.send(serviceID, templateID, templateParams, publicKey);
      
      setMessage('Thanks for signing up! We\'ll keep you updated on Billy\'s WingCo.');
      setMessageType('success');
      setEmail('');
      
      // Clear success message after 5 seconds
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 5000);

    } catch (error) {
      console.error('EmailJS Error:', error);
      
      if (error.message.includes('EmailJS not configured')) {
        setMessage('Email signup is being configured. Please call us at (416) 265-9223 to join our mailing list!');
      } else {
        setMessage('Sorry, there was an error. Please try again or call us at (416) 265-9223.');
      }
      setMessageType('error');
      
      // Clear error message after 8 seconds
      setTimeout(() => {
        setMessage('');
        setMessageType('');
      }, 8000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`w-full max-w-md mx-auto ${className}`}>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row w-full gap-2 sm:gap-0">
        <input
          type="email"
          placeholder="you@example.com"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isLoading}
          className="flex-1 bg-black/70 border border-gray/40 rounded-lg sm:rounded-l-lg sm:rounded-r-none px-4 py-3 sm:py-2
                     placeholder-gray text-ivory focus:outline-none focus:shadow-neonBlue
                     focus:border-neonBlue transition-all duration-200 text-base sm:text-sm
                     min-h-[48px] sm:min-h-[44px] disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <button
          type="submit"
          disabled={isLoading}
          className="bg-neonBlue text-black font-semibold px-4 py-3 sm:py-2 rounded-lg sm:rounded-l-none sm:rounded-r-lg
                     shadow-neonBlue hover:animate-flicker hover:-translate-y-0.5
                     transition-all duration-200 min-h-[48px] sm:min-h-[44px] text-base sm:text-sm
                     whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:transform-none"
        >
          {isLoading ? 'Sending...' : 'Receive Updates'}
        </button>
      </form>
      
      {/* Status Message */}
      {message && (
        <div className={`mt-3 p-3 rounded-lg text-sm text-center transition-all duration-300 ${
          messageType === 'success' 
            ? 'bg-green-900/30 border border-green-500/30 text-green-400' 
            : 'bg-red-900/30 border border-red-500/30 text-red-400'
        }`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default EmailCapture; 